import _ from 'lodash';
import App from 'app/components/root-apps/marketing-app';

const mapStateToProps = state => ({
  ..._.get(state, 'marketing.marketingPage'),
});

const MarketingContainer = mapStateToProps(App);

export default MarketingContainer;



// WEBPACK FOOTER //
// ./app/containers/marketing-page.js